export const videos = {
  bgVideo: require("@/resources/images/main/bg.mp4"),
  loopVideo: require("@/resources/images/main/loop.mp4"),
  pinkRabbit: require("@/resources/images/main/pinkRabbit.mp4"),
  prosNcons: require("@/resources/images/main/prosNcons.mp4"),
};

export const images = {
  pattern: require("@/resources/images/main/pattern.jpg"),
  btn: require("@/resources/images/main/btn.png"),
  reflect: require("@/resources/images/main/reflect.png"),
  txt2: require("@/resources/images/main/txt2.png"),
  line: require("@/resources/images/main/line.png"),
};
